/* Angular Component */
import { Component, Input, OnInit } from "@angular/core";
import { SearchService } from "../../../services/search.service";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "search-input",
  templateUrl: "./searchInput.component.html",
  styleUrls: ["./searchInput.component.scss"],
})
export class SearchInputComponent implements OnInit {
  @Input()
  placeholder;

  searchQuery = "";
  searchServiceHistory = [];
  showHistory = false;

  constructor(
    private searchService: SearchService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.searchQuery = this.searchService.searchQuery;
    if (!this.placeholder) {
      this.placeholder = "Search";
    }
    if (localStorage.getItem("sh") != null) {
      this.searchService.history = JSON.parse(localStorage.getItem("sh"));
    }
    this.searchServiceHistory = this.searchService.history;
    this.searchService.searchServiceSubject.subscribe((_) => {
      this.searchQuery = this.searchService.searchQuery;
    });

    this.route.queryParamMap.subscribe((params) => {
      if (params.has("sq")) {
        this.searchQuery = params.get("sq");
        this.onSearchClick();
      }
    });
  }

  onSearchClick() {
    this.searchService.searchQuery = this.searchQuery;
    if (
      this.searchQuery.trim() !== "" &&
      this.searchService.history.indexOf(this.searchQuery.trim()) === -1
    ) {
      this.searchService.addHistory(this.searchQuery);
      localStorage.setItem("sh", JSON.stringify(this.searchService.history));
    }
    this.searchService.searchServiceSubject.next(true);
  }

  onChange() {
    this.showHistory = false;
  }

  /**
   * Dispatch when blue event occur
   * @param event
   */
  onBlur(event) {
    setTimeout(() => {
      this.showHistory = false;
    }, 10);
  }

  /**
   * Dispatch when keyup event occur
   * @param event
   */
  onKeyup(event) {
    this.showHistory = this.searchQuery === "";
  }

  onClickHistoryItem(searchQueryHistory) {
    this.searchQuery = searchQueryHistory;
    this.showHistory = false;
    this.onSearchClick();
  }
}
